import React, { useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { SECONDARY } from 'constants/types';
import { extractKeysFromObject } from 'utils';
import { analyticsEvents, analyticsPropertiesConstants, track } from 'tracking/segment';
import { DeliveryInfoForm } from 'pages/Totem/TotemDashboard/DeliveryInfoForm';
import { totemUpdatedCacheHandler } from 'utils/cache/totemUpdatedCacheHandler';
import { CloseContainer, PopupTitle } from 'styles/pages/settings.styles';
import { RemoveIcon } from 'styles/components/card.styles';
import { TotemFragmentFragment as Totem, useUpdateTotemAddressMutation } from 'data/__generated__';
import { AddressSelectionProps } from 'pages/Totem/TotemDashboard/TotemDashboard.types';

const addressFields: string[] = ['address', 'zipcode', 'city', 'country', 'latitude', 'longitude'];

interface TotemAddress extends AddressSelectionProps {
    setOrderSelectionStep: (step: number) => void;
}
export const AddressSelection: React.FC<TotemAddress> = ({ currentTotem, handleClose, setOrderSelectionStep }) => {
    const [addressValues, setAddressValues] = useState<Totem | undefined>(currentTotem);
    const apolloClient = useApolloClient();
    const [updateTotemAddress, { loading }] = useUpdateTotemAddressMutation();

    const sendFormContent = async (addressValues: Totem) => {
        if (!currentTotem?._id) return;
        const newAddressValues = extractKeysFromObject(addressValues, addressFields);
        await updateTotemAddress({
            variables: {
                totemId: currentTotem?._id,
                data: {
                    ...newAddressValues,
                },
            },
        });
        totemUpdatedCacheHandler({
            apolloClient,
            currentTotem,
            totemUpdatedValues: newAddressValues,
        });
        track(analyticsEvents.ADD_TOTEM_DELIVERY_ADDRESS, {
            [analyticsPropertiesConstants.ONBOARDING.DELIVERY_CITY]: newAddressValues.city,
        });
    };

    return (
        <>
            <PopupTitle>Renseignez votre adresse de livraison</PopupTitle>
            <DeliveryInfoForm
                currentTotem={currentTotem}
                deliveryInfo={addressValues}
                hasDeliveryInstructions={false}
                hasLocationRestriction={true}
                isAddressNonEditable={currentTotem?.type === SECONDARY}
                loading={loading}
                onFormSubmitted={() => setOrderSelectionStep(1)}
                sendFormContent={sendFormContent}
                setDeliveryInfo={setAddressValues}
                submitLabel="Continuer"
                isCreatingAddress
            />
            <CloseContainer>
                <RemoveIcon size="25px" onClick={handleClose} />
            </CloseContainer>
        </>
    );
};
